<template>
  <div>
    <div class="md-layout">
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/limite"> Cadastro/Limites/Limite </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <md-field
            class="md-layout-item"
            :class="getValidationClass('perfilSelected')"
          >
            <label for="perfilSelected">Perfil</label>
            <md-select
              v-model="perfilSelected"
              name="perfilSelected"
              id="perfilSelected"
            >
              <md-option
                v-for="item in perfis"
                v-bind:key="item.id"
                :value="item.id"
                >{{ item.nome }}
              </md-option>
            </md-select>

            <span class="md-error" v-if="!$v.perfilSelected.required"
              >Perfil obrigatório</span
            >
          </md-field>
          <md-field
            class="md-layout-item"
            :class="getValidationClass('usuarioSelected')"
          >
            <label for="usuarioSelected">Usuario</label>
            <md-select
              v-model="usuarioSelected"
              name="usuarioSelected"
              id="usuarioSelected"
            >
              <md-option
                v-for="item in usuarios"
                v-bind:key="item.id"
                :value="item.id"
                >{{ item.nome }}
              </md-option>
            </md-select>

            <span class="md-error" v-if="!$v.usuarioSelected.required"
              >Usuário obrigatório</span
            >
          </md-field>
          <md-field
            class="md-layout-item"
            :class="getValidationClass('valorLimite')"
          >
            <label>Valor do Limite</label>
            <md-input v-model.lazy="valorLimite" v-money="money"></md-input>
            <span class="md-error" v-if="!$v.valorLimite.required"
              >Valor do limite obrigatório</span
            >
          </md-field>
        </div>
      </div>
    </div>
    <div class="md-layout md-alignment-center-right">
      <label>Adicionar outro limite</label>
      <md-button @click="addLimite(); clear();" class="md-fab md-mini md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-table v-model="limites">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Perfil">{{ item.perfil }}</md-table-cell>
            <md-table-cell md-label="Usuario">{{ item.usuario }}</md-table-cell>
            <md-table-cell md-label="Valor Limite">{{
              item.valorLimite
            }}</md-table-cell>
            <md-table-cell md-label="Editar">
              <md-button
                class="md-icon-button md-primary"
                @click="editaLimite(item.index)"
              >
                <md-icon>edit</md-icon></md-button
              >
              <md-tooltip md-direction="top">Editar limite</md-tooltip>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
    <div class="md-layout-item">
      <div class="md-layout md-alignment-center-right">
        <md-button to="/limite" class="md-raised md-warning"
          >Voltar</md-button
        >
        <md-button @click="enviarLista" class="md-raised md-success"
          >Salvar</md-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { enviarLimiteAsync } from "../../../services/limiteService";
import { mapState } from "vuex";
import { VMoney } from "v-money";

export default {
  name: "criarLimite",
  data: () => ({
    valorLimite: null,
    perfilSelected: null,
    usuarioSelected: null,
    limites: [],
    limite: {
      idPerfil: null,
      perfil: null,
      idUsuario: null,
      usuario: null,
      valorLimite: null,
      index: null,
    },
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      //suffix: " #",
      precision: 2,
      masked: false,
    },
  }),
  directives: { money: VMoney },
  mixins: [validationMixin],
  validations: {
    valorLimite: { required },
    perfilSelected: { required },
    usuarioSelected: { required },
  },
  computed: {
    ...mapState("perfil", ["perfis"]),
    ...mapState("usuario", ["usuarios"]),
  },
  methods: {
    enviarLista() {
      if (this.limites.length) {
        this.limites.forEach(this.enviar);
      } else {
        this.$alert("", "A lista de limites está vazia!", "error");
      }
    },
    async enviar(item) {
      const resposta = await enviarLimiteAsync(
        item.idPerfil,
        item.idUsuario,
        item.valorLimite.replace("R$ ", "")
      );
      if (resposta) {
        //this.mensagemErro = resposta;
        //this.mostartMensagemErro = true;
        this.$alert(resposta.message, "Descupe, falha na operação!", "error");
      } else {
        /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
        if (item.index == this.limites.length);
        {
          this.$router.push("/limite");
        }
      }
    },
    addLimite() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.limite.index =
          this.limites.length === 0
            ? 0
            : this.limites[this.limites.length - 1].index + 1;
        this.limite.idPerfil = this.perfilSelected;
        this.limite.perfil = this.findPerfil(this.perfilSelected).descricao;
        this.limite.idUsuario = this.usuarioSelected;
        this.limite.usuario = this.findUsuario(this.usuarioSelected).nome;
        this.limite.valorLimite = this.valorLimite;

        this.limites.push(JSON.parse(JSON.stringify(this.limite)));
        this.limite.idPerfil = null;
        this.limite.idUsuario = null;
        this.limite.perfil = null;
        this.limite.usuario = null;
        this.limite.valorLimite = null;
      }
    },

    editaLimite(index) {
      var limite = this.limites.filter((l) => l.index === index);
      alert(JSON.stringify(limite));
      if (limite) {
        this.perfilSelected = limite[0].idPerfil;
        this.usuarioSelected = limite[0].idUsuario;
        this.valorLimite = limite[0].valorLimite;
        this.removeLimite(index);
      }
    },
    clear()
    {
        this.perfilSelected = null;
        this.usuarioSelected = null;
        this.valorLimite = null;
    },
    removeLimite(index) {
      this.limites = this.limites.filter((e) => e.index != index);
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    findPerfil(perfilId) {
      return this.perfis.find((pf) => pf.id === perfilId && pf.ativo == true);
    },
    findUsuario(usuarioId) {
      return this.usuarios.find((u) => u.id === usuarioId);
    },
  },
};
</script>

<style scoped>
.md-field {
  margin: 10px;
}

.vl {
  margin: 0px 50px;
  border-left: 2px dashed var(--md-theme-default-primary);
}

.icone-voltar {
  vertical-align: text-bottom;
}

.md-card {
  width: 140px;
  margin: 2px;
  display: inline-block;
  vertical-align: top;
}

.labelBar {
  margin-right: 10px;
  margin-left: 10px;
}
</style>